import { useMemo } from "react";
import { useSelector } from "react-redux";

export default (itemsToShow = 10) => {
    const { auditAssets } = useSelector((state) => state);

    let dataUnchecked = useMemo(() => {
        return auditAssets.data
            .filter(
                (item) =>
                    !item.isAssigned && item.isMandatory && item.isExpected
            )
            .sort((a, b) => a.deferredTimestamp - b.deferredTimestamp);
    }, [auditAssets.data]);

    const uncheckedCount = dataUnchecked.length;

    dataUnchecked = dataUnchecked
        .slice(0, itemsToShow)
        .sort((a, b) => a.deferredTimestamp - b.deferredTimestamp);

    return [uncheckedCount, dataUnchecked];
};
